import "core-js/modules/es.function.name.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-29d74e59"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "logo"
};
var _hoisted_2 = {
  href: "/",
  target: "_blank"
};
var _hoisted_3 = {
  class: "nav",
  router: ""
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "nav-title router-link-active"
};
var _hoisted_6 = {
  class: "text"
};
import { ref } from 'vue';
import { menusList } from './menusList';
import { useRouter } from 'vue-router';
export default {
  setup: function setup(__props) {
    var router = useRouter();
    var redirectPath = ref(sessionStorage.getItem('path') || '/homePage');

    var savePath = function savePath(path) {
      sessionStorage.setItem('path', "".concat(path));
      redirectPath.value = path;
      router.push(path);
    };

    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");

      var _component_el_icon = _resolveComponent("el-icon");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("a", _hoisted_2, [_createVNode(_component_svg_icon, {
        icon: "logo",
        class: "img"
      })])]), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menusList), function (item) {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["nav-item", {
            on: item.path === redirectPath.value
          }]),
          key: item.path,
          onClick: function onClick($event) {
            return savePath(item.path);
          }
        }, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_icon, {
          class: "icon h-icon-zonglan"
        }, {
          default: _withCtx(function () {
            return [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))];
          }),
          _: 2
        }, 1024), _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)])], 10, _hoisted_4);
      }), 128))])], 64);
    };
  }
};